function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M34.964 82.578H30.1c-5.5 0-10-4.5-10-10V30.1c0-5.5 4.5-10 10-10h65.99c5.5 0 10 4.5 10 10v3.864",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M110.347 33.964H44.444c-5.214 0-9.48 4.266-9.48 9.479v41.528c0 5.214 4.266 9.479 9.48 9.479h20.431l12.803 19.41L90.48 94.45h19.867c5.213 0 9.479-4.265 9.479-9.479V43.443c0-5.213-4.266-9.479-9.479-9.479z",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 4
});

function SvgConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 134",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 10
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQwIDEzNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIj4KICA8cGF0aCBkPSJNMzQuOTY0IDgyLjU3OEgzMC4xYy01LjUgMC0xMC00LjUtMTAtMTBWMzAuMWMwLTUuNSA0LjUtMTAgMTAtMTBoNjUuOTljNS41IDAgMTAgNC41IDEwIDEwdjMuODY0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSI0Ii8+CiAgPHBhdGggZD0iTTExMC4zNDcgMzMuOTY0SDQ0LjQ0NGMtNS4yMTQgMC05LjQ4IDQuMjY2LTkuNDggOS40Nzl2NDEuNTI4YzAgNS4yMTQgNC4yNjYgOS40NzkgOS40OCA5LjQ3OWgyMC40MzFsMTIuODAzIDE5LjQxTDkwLjQ4IDk0LjQ1aDE5Ljg2N2M1LjIxMyAwIDkuNDc5LTQuMjY1IDkuNDc5LTkuNDc5VjQzLjQ0M2MwLTUuMjEzLTQuMjY2LTkuNDc5LTkuNDc5LTkuNDc5eiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iNCIvPgo8L3N2Zz4=";
export { SvgConversation as ReactComponent };